import { useQuery } from "@tanstack/react-query";
import {
  fetchPortfolioOverview,
  type PortfolioStats,
} from "../api/crm";

export const PORTFOLIO_OVERVIEW_QUERY_KEY = [
  "crm",
  "portfolio",
  "overview",
] as const;

/**
 * Fetches the six-stat portfolio snapshot that sits above the customer table.
 * The backend serves from a nightly-cron'd row, so this is essentially
 * instant. 10-minute staleTime matches the customer-list hook — one refetch
 * per coffee break keeps the UI responsive without hammering the DB.
 */
export function usePortfolioOverview() {
  return useQuery<PortfolioStats>({
    queryKey: PORTFOLIO_OVERVIEW_QUERY_KEY,
    queryFn: fetchPortfolioOverview,
    staleTime: 10 * 60 * 1000,
  });
}
